// START::: [BD Feat] Align the Header and Product MediaCarousel

(function(){
  function alignCarouselAndLastMedia() {
    const header   = document.querySelector('.header');
    const carousel = document.querySelector('.product-gallery__media-list');
    const meta     = document.querySelector('.product-info-inner');
    if (!header || !carousel || !meta) return;

    // 1) bereken horizontale offset op basis van --site-content-width
    const rs        = getComputedStyle(document.documentElement);
    const raw       = rs.getPropertyValue('--site-content-width').trim();
    const rootFs    = parseFloat(rs.fontSize);
    const contentPx = raw.endsWith('rem')
      ? parseFloat(raw) * rootFs
      : parseFloat(raw);
    const vw        = window.innerWidth;
    const off       = vw > contentPx ? (vw - contentPx) / 2 : 0;

    // 2) shift & size de carousel
    Object.assign(carousel.style, {
      paddingLeft: `${off}px`,
      width:       '100vw',
      overflowX:   'auto',
    });

    // 3) bereken afstand van viewport-linkerrand tot header
    const headerRect = header.getBoundingClientRect();
    const headerOffset = headerRect.left;

    // 4) bepaal breedte van de “product meta”
    const metaWidth = meta.getBoundingClientRect().width;

    // 6) Pak het laatste product-media element, bereken padding-right t.o.v. rechterzijde header
    if (vw >= 1000) {
       const items = carousel.querySelectorAll('.product-gallery__media');
    const lastItem = items[items.length - 1];
    if (lastItem) {
      const distanceRight = vw - headerRect.right + 32;
      Object.assign(lastItem.style, {
        paddingRight: `${distanceRight}px`,
        width:        'max-content',
      });
    }
    }
  }

  // initial run & bij elke resize
  alignCarouselAndLastMedia();
  window.addEventListener('resize', alignCarouselAndLastMedia);

  var SummaryFullTextApp = (() => {
    var close = (element) => {
      if (!element) return;
      const summaryElement = element.querySelector('[js-summary-text]');
      const fullElement = element.querySelector('[js-full-text]');
      if (!summaryElement || !fullElement) return;
      const minHeight = summaryElement.offsetHeight;
      fullElement.style.height = minHeight + 'px';
      element.classList.remove('expanded');
      summaryElement.style.visibility = 'hidden';
      setTimeout(() => {
        summaryElement.style.visibility = 'visible';
      }, 300);
    }
    var open = (element) => {
      if (!element) return;
      const summaryElement = element.querySelector('[js-summary-text]');
      const fullElement = element.querySelector('[js-full-text]');
      if (!summaryElement || !fullElement) return;
      const maxHeight = fullElement.scrollHeight;
      fullElement.style.height = maxHeight + 'px';
      element.classList.add('expanded');
      summaryElement.style.visibility = 'hidden';
    }
    var initialize = () => {
      document.querySelectorAll('[js-summary-full-text-container]').forEach(element => {
        close(element);
      });
      document.querySelectorAll('[js-summary-full-text-container] [js-toggle-button]').forEach(toggleButton => {
        const element = toggleButton.closest('[js-summary-full-text-container]');
        toggleButton.addEventListener('click', () => {
          if (element.classList.contains('expanded')) {
            close(element);
          } else {
            open(element);
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      SummaryFullTextApp.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });
})();
    
// END::: [BD Feat] Align the Header and Product MediaCarousel
